export default __webpack_public_path__ + "static/Promo_Tablet-364e3679319f1a2efacca5d327d60aee.webp";